export enum PaymentMethodEnum {
    Transferencia = 1,
    Efectivo = 2,
}